import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Slider = ({ children }) => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <div className="relative">
      {/* Left scroll button */}
      <button
        onClick={scrollLeft}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-apple-bg border border-apple-divider rounded-full p-2 shadow-apple hover:shadow-apple-lg transition-all duration-200 apple-hover"
        aria-label="Scroll left"
      >
        <ChevronLeft size={16} className="text-apple-text-primary" />
      </button>

      {/* Right scroll button */}
      <button
        onClick={scrollRight}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-apple-bg border border-apple-divider rounded-full p-2 shadow-apple hover:shadow-apple-lg transition-all duration-200 apple-hover"
        aria-label="Scroll right"
      >
        <ChevronRight size={16} className="text-apple-text-primary" />
      </button>

      {/* Scrollable content */}
      <div 
        ref={scrollRef}
        className="flex overflow-x-auto space-x-3 sm:space-x-4 pb-4 -mx-4 px-4 scrollbar-hide smooth-scroll touch-manipulation"
      >
        {React.Children.map(children, (child, index) => (
          <div key={index} className="flex-shrink-0 w-32 sm:w-40 md:w-44 lg:w-48">
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slider;